/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PredictedEndDateModalChartSection_project = {
    readonly projectStartYear: number | null;
    readonly projectStartMonth: number | null;
    readonly projectStartDay: number | null;
    readonly projectEndYear: number | null;
    readonly projectEndMonth: number | null;
    readonly projectEndDay: number | null;
    readonly projectHealth: {
        readonly totalTaskEstimate: number | null;
        readonly totalBaselineEstimate: number | null;
        readonly totalTaskEstimateDone: number | null;
        readonly predictedEndDate: string | null;
        readonly optimisticPredictedEndDate: string | null;
        readonly conservativePredictedEndDate: string | null;
        readonly predictedScopePerDay: ReadonlyArray<{
            readonly date: string | null;
            readonly value: number | null;
        } | null> | null;
        readonly optimisticPredictedScopePerDay: ReadonlyArray<{
            readonly date: string | null;
            readonly value: number | null;
        } | null> | null;
        readonly conservativePredictedScopePerDay: ReadonlyArray<{
            readonly date: string | null;
            readonly value: number | null;
        } | null> | null;
        readonly predictedAverageScopePerDay: number | null;
        readonly optimisticAverageScopePerDay: number | null;
        readonly conservativeAverageScopePerDay: number | null;
    } | null;
    readonly " $refType": "PredictedEndDateModalChartSection_project";
};
export type PredictedEndDateModalChartSection_project$data = PredictedEndDateModalChartSection_project;
export type PredictedEndDateModalChartSection_project$key = {
    readonly " $data"?: PredictedEndDateModalChartSection_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PredictedEndDateModalChartSection_project">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PredictedEndDateModalChartSection_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectStartYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectStartMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectStartDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectHealth",
      "kind": "LinkedField",
      "name": "projectHealth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalTaskEstimate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalBaselineEstimate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalTaskEstimateDone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "predictedEndDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optimisticPredictedEndDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conservativePredictedEndDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "predictedScopePerDay",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "optimisticPredictedScopePerDay",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "conservativePredictedScopePerDay",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "predictedAverageScopePerDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optimisticAverageScopePerDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conservativeAverageScopePerDay",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
})();
(node as any).hash = '585699852fc1f7a3d8681e9a0bcce76b';
export default node;
